
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import CollapseItem from '@/components/collapse.vue';
import uploadImg from "@/components/upload-img.vue"
import Switch from '@/components/switch.vue';
import Dialog from '@/components/dialog.vue';
import choosePrize from '@/components/choosePrize.vue';
import chooseCoupon from '@/components/chooseCoupon.vue';
import {
	activityTaskRewardactivityTaskRewardDetail,
	activityTaskRewardactivityTaskRewardSave
} from "@/api/live"
import axios from 'axios';
@Component({
	name: '',
	components: {
		PageFooter,
		CollapseItem,
		uploadImg,
		'slz-switch': Switch,
		'slz-dialog': Dialog,
		choosePrize,
		chooseCoupon,
	}
})

export default class ProductList extends Vue {
	private loading = false
	private form: any = {
		Id: 0,
		ActivityState: 0,
		ActivityName: '',
		ActivityStartTime: '',
		ActivityEndTime: '',
		ActivityRule: '',
		ActivityPosterImgUrl: '',
		JoinObject: 2,
		JoinObjectRole: [1, 2, 3],
		ConditionsFirstNearlyDays: '',
		ConditionsFirstMinRetailSellMoney: '',
		ConditionsFirstMaxRetailSellMoney: '',
		ConditionsSecondNearlyDays: '',
		ConditionsSecondMinRetailOrderCount: '',
		ConditionsSecondMaxRetailOrderCount: '',
		IsNeedTogether: true,
		FileName: '',
		FileUrl: '',
		IsNewFile: true,
		RewardType: 1,
		RewardRelationId: '',
		RewardRelationRemark: '',
		prizeId: 0,
		prizeName: '',
		RedPacketMoney: '',
		RedPacketUseTimeType: 0,
		RedPacketStartTime: '',
		RedPacketEndTime: '',
		RedPacketUseDays: '',
		couponId: 0,
		couponName: '',
		SendPoint: '',
		PointEffectiveDays: 365,
		RedPacketUseRuleInstruction: '',

		IsCheckFirstTask: false,
		ContinuTranspondProductDays: '',
		IsCheckSecondTask: false,
		ShareProductCustomerVisitCount: '',
		IsCheckThirdthTask: false,
		DealNewCustomerCount: '',
		IsCheckFourthTask: false,
		InviteNewAgentCount: '',
		IsCheckFifthTask: false,
		ActivateRunOffAgentCount: '',
		IsCheckSixthTask: false,
		RetailPerformanceNearlyDays: '',
		MinRetailPerformance: '',
		IsCheckSeventhTask: false,
		RetailOrderNearlyDays: '',
		MinRetailOrderCount: '',
	}
	private gradelist = [
		{
			label: 'SVIC',
			value: 1
		}, {
			label: 'VIC',
			value: 2
		},
		{
			label: 'VIP',
			value: 3
		},
	]
	private IdFile: any = []
	private impShow = false
	private result: any = {
		FileCount: 0
	}
	private prizeShow = false
	private prizeData: any = {}
	private couponShow = false
	private couponData: any = []
	private tablelist: any = [
		{
			Id: 1,
			Name: '连续转发商品天数：',
			Count: '',
			IsCheck: false,
		},
		{
			Id: 2,
			Name: '分享的商品客户浏览人数：',
			Count: '',
			IsCheck: false,
		},
		{
			Id: 3,
			Name: '成交新客户数量：',
			Count: '',
			IsCheck: false,
		},
		{
			Id: 4,
			Name: '成功邀请新代理数量：',
			Count: '',
			IsCheck: false,
		},
		{
			Id: 5,
			Name: '激活流失代理(90天无交易的直推代理)：',
			Count: '',
			IsCheck: false,
		},
		{
			Id: 6,
			Days: '',
			Count: '',
			IsCheck: false,
		},
		{
			Id: 7,
			Days: '',
			Count: '',
			IsCheck: false,
		},
	]

	private mounted() {
		if (Number(this.$route.query.Id) > 0) {
			this.getInfo()
		}
	}

	private async getInfo() {
		try {
			this.loading = true
			let res: any = await activityTaskRewardactivityTaskRewardDetail({
				Id: this.$route.query.Id
			})
			if (res.IsSuccess) {
				let form = JSON.parse(JSON.stringify(res.Result))
				if (form.JoinObject != 2) {
					form.JoinObjectRole = [1, 2, 3]
					form.IsNeedTogether = true
				}
				if (form.JoinObject == 3) {
					this.IdFile = [form.FileUrl]
				}
				if (form.RewardType == 1) {
					form.prizeId = form.RewardRelationId
					form.prizeName = form.RewardRelationRemark
					this.prizeData = {
						Id: form.RewardRelationId,
						RewardRelationRemark: form.RewardRelationRemark
					}
				} else if (form.RewardType == 3) {
					form.couponId = form.RewardRelationId
					form.couponName = form.RewardRelationRemark
					this.couponData = [{
						Id: form.RewardRelationId,
						RewardRelationRemark: form.RewardRelationRemark
					}]
				} else {
					form.couponId = ''
					form.couponName = ''
				}
				if (new Date().getTime() < new Date(form.ActivityStartTime).getTime()) {
					form.ActivityState = 0
				} else if (new Date().getTime() > new Date(form.ActivityEndTime).getTime()) {
					form.ActivityState = 2
				} else {
					form.ActivityState = 3
				}
				this.form = JSON.parse(JSON.stringify(form))
				this.makeTable()
			}
		} finally {
			this.loading = false
		}
	}
	private makeTable() {
		this.tablelist = this.tablelist.map(v => {
			if (v.Id == 1) {
				v.IsCheck = this.form.IsCheckFirstTask
				v.Count = this.form.ContinuTranspondProductDays
			} else if (v.Id == 2) {
				v.IsCheck = this.form.IsCheckSecondTask
				v.Count = this.form.ShareProductCustomerVisitCount
			} else if (v.Id == 3) {
				v.IsCheck = this.form.IsCheckThirdthTask
				v.Count = this.form.DealNewCustomerCount
			} else if (v.Id == 4) {
				v.IsCheck = this.form.IsCheckFourthTask
				v.Count = this.form.InviteNewAgentCount
			} else if (v.Id == 5) {
				v.IsCheck = this.form.IsCheckFifthTask
				v.Count = this.form.ActivateRunOffAgentCount
			} else if (v.Id == 6) {
				v.IsCheck = this.form.IsCheckSixthTask
				v.Count = this.form.MinRetailPerformance
				v.Days = this.form.RetailPerformanceNearlyDays
			} else if (v.Id == 7) {
				v.IsCheck = this.form.IsCheckSeventhTask
				v.Count = this.form.MinRetailOrderCount
				v.Days = this.form.RetailOrderNearlyDays
			}
			return v
		})
	}
	private check() {
		let form = JSON.parse(JSON.stringify(this.form))
		let two = /^\d+(\.\d{1,2})?$/
		if (!form.ActivityName) {
			this.$message.error('请输入活动名称')
			return false
		}
		if (!form.ActivityStartTime || !form.ActivityEndTime) {
			this.$message.error('请完善活动时间')
			return false
		}
		if (new Date(form.ActivityStartTime).getTime() > new Date(form.ActivityEndTime).getTime()) {
			this.$message.error('开始时间不能晚于结束时间')
			return false
		}
		if (form.ActivityState == 0 && new Date(form.ActivityStartTime).getTime() < new Date().getTime()) {
			this.$message.error('请设置未来时间作为活动时间')
			return false
		}
		if (!form.ActivityRule) {
			this.$message.error('请填写活动说明，方便用户更好了解活动细则')
			return false
		}
		if (!form.ActivityPosterImgUrl) {
			this.$message.error('请上传活动页面海报图')
			return false
		}
		if (form.JoinObject == 2) {
			if (!form.JoinObjectRole || !form.JoinObjectRole.length) {
				this.$message.error('请设置参与对象')
				return false
			}
			if (form.ConditionsFirstNearlyDays < 0 || form.ConditionsFirstNearlyDays > 90) {
				this.$message.error('参与对象的业绩时长最多90天')
				return false
			}
			if (form.ConditionsFirstMinRetailSellMoney < 0 || form.ConditionsFirstMinRetailSellMoney > 1000000
				|| form.ConditionsFirstMaxRetailSellMoney < 0 || form.ConditionsFirstMaxRetailSellMoney > 1000000
				|| !two.test(form.ConditionsFirstMinRetailSellMoney) || !two.test(form.ConditionsFirstMaxRetailSellMoney)) {
				this.$message.error('零售交易额允许的数值0~100万的两位小数')
				return false
			}
			if (form.ConditionsFirstMinRetailSellMoney > form.ConditionsFirstMaxRetailSellMoney) {
				this.$message.error('最小金额不可大于最大金额')
				return false
			}
			if (form.ConditionsSecondNearlyDays < 0 || form.ConditionsSecondNearlyDays > 90) {
				this.$message.error('参与对象的业绩时长最多90天')
				return false
			}
			if (form.ConditionsSecondMinRetailOrderCount < 0 || form.ConditionsSecondMinRetailOrderCount > 1000000 || form.ConditionsSecondMaxRetailOrderCount < 0 || form.ConditionsSecondMaxRetailOrderCount > 1000000) {
				this.$message.error('零售订单数允许的数值0~100万的整数')
				return false
			}
			if (form.ConditionsSecondMinRetailOrderCount > form.ConditionsSecondMaxRetailOrderCount) {
				this.$message.error('最小数量不可大于最大数量')
				return false
			}
			if (form.ConditionsFirstNearlyDays > 0 && (form.ConditionsFirstMinRetailSellMoney == 0 || form.ConditionsFirstMaxRetailSellMoney == 0)) {
				this.$message.error('请完善参与对象的条件')
				return false
			}
			if (form.ConditionsSecondNearlyDays > 0 && (form.ConditionsSecondMinRetailOrderCount == 0 || form.ConditionsSecondMaxRetailOrderCount == 0)) {
				this.$message.error('请完善参与对象的条件')
				return false
			}
		} else if (form.JoinObject == 3) {
			if (!form.FileUrl) {
				this.$message.error('请上传指定代理文件')
				return false
			}
		}
		if (!form.RewardType) {
			this.$message.error('请选择奖励内容')
			return false
		}
		if (form.RewardType == 1) {
			if (!form.prizeId) {
				this.$message.error('请选择大转盘抽奖')
				return false
			}
		} else if (form.RewardType == 2) {
			if (!form.RedPacketMoney) {
				this.$message.error('请填写红包金额')
				return false
			}
			if (form.RedPacketMoney < 0.01 || form.RedPacketMoney > 999.99 || !two.test(form.RedPacketMoney)) {
				this.$message.error('红包金额限制0.01~999.99')
				return false
			}
			if (!form.RedPacketUseTimeType) {
				this.$message.error('请设置红包使用日期')
				return false
			}
			if (form.RedPacketUseTimeType == 1) {
				if (new Date(form.RedPacketStartTime).getTime() > new Date(form.RedPacketEndTime).getTime()) {
					this.$message.error('开始时间不能晚于结束时间')
					return false
				}
				if (new Date().getTime() > new Date(form.RedPacketEndTime).getTime()) {
					this.$message.error('使用期限不得早于当前时间')
					return false
				}
			} else {
				if (!form.RedPacketUseDays || form.RedPacketUseDays < 1 || form.RedPacketUseDays > 9999) {
					this.$message.error('使用期限允许1~9999天')
					return false
				}
			}
		} else if (form.RewardType == 3) {
			if (!form.couponId) {
				this.$message.error('请选择优惠券')
				return false
			}
		} else if (form.RewardType == 4) {
			if (!form.SendPoint) {
				this.$message.error('请填写积分数量')
				return false
			}
			if (form.SendPoint < 1 || form.SendPoint > 1000000) {
				this.$message.error('积分限制1~100万')
				return false
			}
		}
		let list = this.tablelist.some(v => v.IsCheck)
		if (!list) {
			this.$message.error('请设置至少一个任务内容')
			return false
		}
		for (let item of this.tablelist) {
			if (item.IsCheck) {
				if (item.Id == 1) {
					if (!item.Count) {
						this.$message.error('请设置任务之连续转发商品天数')
						return false
					}
					if (item.Count < 1 || item.Count > 365) {
						this.$message.error('转发天数允许1~365')
						return false
					}
				}
				if (item.Id == 2) {
					if (!item.Count) {
						this.$message.error('请设置任务之分享的商品客户浏览数量')
						return false
					}
					if (item.Count < 1 || item.Count > 9999) {
						this.$message.error('商品的客户浏览数量允许1~9999')
						return false
					}
				}
				if (item.Id == 3) {
					if (!item.Count) {
						this.$message.error('请设置任务之成交新客户数量')
						return false
					}
					if (item.Count < 1 || item.Count > 9999) {
						this.$message.error('成交客户数量允许1~9999')
						return false
					}
				}
				if (item.Id == 4) {
					if (!item.Count) {
						this.$message.error('请设置任务之成功邀请新代理数量')
						return false
					}
					if (item.Count < 1 || item.Count > 9999) {
						this.$message.error('成功邀请新代理数量允许1~9999')
						return false
					}
				}
				if (item.Id == 5) {
					if (!item.Count) {
						this.$message.error('请设置任务之激活流失代理数量')
						return false
					}
					if (item.Count < 1 || item.Count > 9999) {
						this.$message.error('激活流失代理数量允许1~9999')
						return false
					}
				}
				if (item.Id == 6) {
					if (item.Days < 1 || item.Days > 90) {
						this.$message.error('零售业绩的时长最多90天')
						return false
					}
					if (!String(item.Count)) {
						this.$message.error('请设置任务之零售业绩')
						return false
					}
					if (item.Count < 0 || item.Count > 1000000 || !two.test(item.Count)) {
						this.$message.error('零售业绩允许0~100万')
						return false
					}
				}
				if (item.Id == 7) {
					if (item.Days < 1 || item.Days > 90) {
						this.$message.error('零售订单数的时长最多90天')
						return false
					}
					if (!String(item.Count)) {
						this.$message.error('请设置任务之零售订单数')
						return false
					}
					if (item.Count < 0 || item.Count > 1000000) {
						this.$message.error('零售订单数允许0~100万')
						return false
					}
				}
			}
		}

		return true
	}
	private async save() {
		if (!this.check()) return
		let form = JSON.parse(JSON.stringify(this.form))
		if (form.JoinObject == 1) {
			form.JoinObjectRole = []
			form.ConditionsFirstNearlyDays = ''
			form.ConditionsFirstMinRetailSellMoney = ''
			form.ConditionsFirstMaxRetailSellMoney = ''
			form.ConditionsSecondNearlyDays = ''
			form.ConditionsSecondMinRetailOrderCount = ''
			form.ConditionsSecondMaxRetailOrderCount = ''
			form.FileUrl = ''
			form.FileName = ''
		} else if (form.JoinObject == 2) {
			form.FileUrl = ''
			form.FileName = ''

			form.ConditionsFirstMinRetailSellMoney = form.ConditionsFirstMinRetailSellMoney || 0
			form.ConditionsFirstMaxRetailSellMoney = form.ConditionsFirstMaxRetailSellMoney || 0
			form.ConditionsSecondMinRetailOrderCount = form.ConditionsSecondMinRetailOrderCount || 0
			form.ConditionsSecondMaxRetailOrderCount = form.ConditionsSecondMaxRetailOrderCount || 0
		} else {
			form.JoinObjectRole = []
			form.ConditionsFirstNearlyDays = ''
			form.ConditionsFirstMinRetailSellMoney = ''
			form.ConditionsFirstMaxRetailSellMoney = ''
			form.ConditionsSecondNearlyDays = ''
			form.ConditionsSecondMinRetailOrderCount = ''
			form.ConditionsSecondMaxRetailOrderCount = ''
		}

		form.RewardRelationId = ''
		form.RewardRelationRemark = ''
		if (form.RewardType == 1) {
			form.RedPacketMoney = ''
			form.RedPacketUseTimeType = 0
			form.RedPacketStartTime = ''
			form.RedPacketEndTime = ''
			form.RedPacketUseDays = ''
			form.RedPacketUseRuleInstruction = ''

			form.couponId = ''
			form.couponName = ''
			form.youhuiquanjine = ''

			form.SendPoint = ''

			form.RewardRelationId = form.prizeId
			form.RewardRelationRemark = form.prizeName
		} else if (form.RewardType == 2) {
			form.prizeId = ''
			form.prizeName = ''
			form.choujiangkaishi = ''
			form.choujiangjieshu = ''

			form.couponId = ''
			form.couponName = ''
			form.youhuiquanjine = ''

			form.SendPoint = ''

			if (form.RedPacketUseTimeType == 1) {
				form.RedPacketUseDays = ''
			} else {
				form.RedPacketStartTime = ''
				form.RedPacketEndTime = ''
			}
		} else if (form.RewardType == 3) {
			form.prizeId = ''
			form.prizeName = ''
			form.choujiangkaishi = ''
			form.choujiangjieshu = ''

			form.RedPacketMoney = ''
			form.RedPacketUseTimeType = 0
			form.RedPacketStartTime = ''
			form.RedPacketEndTime = ''
			form.RedPacketUseDays = ''
			form.RedPacketUseRuleInstruction = ''

			form.SendPoint = ''

			form.RewardRelationId = form.couponId
			form.RewardRelationRemark = form.couponName
		} else if (form.RewardType == 4) {
			form.prizeId = ''
			form.prizeName = ''
			form.choujiangkaishi = ''
			form.choujiangjieshu = ''

			form.RedPacketMoney = ''
			form.RedPacketUseTimeType = 0
			form.RedPacketStartTime = ''
			form.RedPacketEndTime = ''
			form.RedPacketUseDays = ''
			form.RedPacketUseRuleInstruction = ''

			form.couponId = ''
			form.couponName = ''
			form.youhuiquanjine = ''
		}

		this.tablelist.map(v => {
			if (v.Id == 1) {
				form.IsCheckFirstTask = v.IsCheck
				form.ContinuTranspondProductDays = v.Count
			} else if (v.Id == 2) {
				form.IsCheckSecondTask = v.IsCheck
				form.ShareProductCustomerVisitCount = v.Count
			} else if (v.Id == 3) {
				form.IsCheckThirdthTask = v.IsCheck
				form.DealNewCustomerCount = v.Count
			} else if (v.Id == 4) {
				form.IsCheckFourthTask = v.IsCheck
				form.InviteNewAgentCount = v.Count
			} else if (v.Id == 5) {
				form.IsCheckFifthTask = v.IsCheck
				form.ActivateRunOffAgentCount = v.Count
			} else if (v.Id == 6) {
				form.IsCheckSixthTask = v.IsCheck
				form.MinRetailPerformance = v.Count
				form.RetailPerformanceNearlyDays = v.Days
			} else if (v.Id == 7) {
				form.IsCheckSeventhTask = v.IsCheck
				form.MinRetailOrderCount = v.Count
				form.RetailOrderNearlyDays = v.Days
			}
		})

		try {
			this.loading = true
			let res: any = await activityTaskRewardactivityTaskRewardSave(form)
			if (res.IsSuccess) {
				this.$message.success('保存成功')
				this.$router.go(-1)
			}
		} finally {
			this.loading = false
		}
	}
	private getcouponData(e) {
		if (!e || !e.length) {
			this.form.couponId = ''
			this.form.couponName = ''
			this.couponData = []
			return
		}
		this.form.couponId = e[0].Id
		this.form.couponName = e[0].RewardRelationRemark || `${e[0].CouponName}（金额：${e[0].DerateMoney}元）`
		this.couponData = e
		this.couponShow = false
	}
	private getprizeData(e) {
		this.form.prizeId = e.Id
		this.form.prizeName = e.RewardRelationRemark || `${e.Name}（抽奖时间：${e.StartTime}至${e.EndTime}）`
		this.prizeData = e
		this.prizeShow = false
	}
	private async confirmUpload(needDown) {
		if (!this.form.FileUrl) {
			this.$message.error('请上传指定代理文件')
			return
		}
		try {
			let res: any = await axios.get('/pc/activityTaskReward/activityTaskRewardImportDataValite' + `?ExcelFilePath=${this.form.FileUrl}&ExcelFileName=${this.form.FileName}`, {
				responseType: needDown ? 'blob' : undefined,
			})
			// console.log(res.data.IsSuccess)
			if (needDown) {
				let blob = new Blob([res.data], { type: "application/octet-stream; charset=utf-8" })
				let a = document.createElement('a')
				a.style.display = 'none'
				a.download = `导入指定代理反馈表格.xlsx`
				a.href = URL.createObjectURL(blob)
				a.click()
				a.remove()
				return
			} else {
				if (res.data.IsSuccess == undefined) {
					this.impShow = true
					this.result = {
						Result: false,
					}
					this.confirmUpload(true)
				} else if (!res.data.IsSuccess) {
					this.$message.error(res.data.Message)
				} else {
					this.impShow = true
					this.result = {
						Result: true,
					}
				}
			}

		} finally {
			//
		}
	}
	private uploadSuc2(file, name) {
		this.form.FileName = name
		this.form.FileUrl = file[0]
		this.IdFile = file
		this.form.IsNewFile = true
	}
	private uploadSuc(file, key) {
		this.form[key] = file[0]
	}
}
